import config from '@genially/ui/build/config/config';

const replaceUrl = (defaultUrl: string, dynamicSlug: string) => {
  switch (config.appEnv) {
    case 'dynamic':
      return `https://${window.location.hostname}`.replace('play-', `${dynamicSlug}-`);
    default:
      return defaultUrl;
  }
};

export const env = {
  ...config,
  appUrls: {
    ...config.appUrls,
    view: replaceUrl(config.appUrls.view, 'view'),
    p2pServer: replaceUrl(config.appUrls.p2pServer, 'p2p'),
  },
  p2pDefaultPath: 'p2p',
};

export const getDefaultLoggerApp = () => {
  if (window.location.href.startsWith(env.appUrls.play)) {
    return '@genially/play';
  }

  return 'p2p-client';
};
